import React from 'react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { Divider, Col, Row, Input, Form, Space, Button, DatePicker, Select, InputNumber } from 'antd';
import { HookAPI } from 'antd/es/modal/useModal';
import { NotificationInstance } from 'antd/es/notification/interface';

import IBaseComponentProps from '@components/base-component-props';
import CargoCarrier from '@components/cargo-carrier/cargo-carrier';

import Trackpoints from './trackpoints';

import { ITruck } from '@entities/truck';
import { IWaypointHeader } from '@entities/waypoint-header';

import { TruckStatus, enumLabel } from '@enums/truck-status';
import { CargoCarrierType } from '@enums/cargo-carrier-type';

dayjs.extend(utc);

interface ITruckWeb extends IBaseComponentProps {
    truck: ITruck;
    modal: HookAPI;
    headers: Array<IWaypointHeader>;
    loading: boolean;
    api: NotificationInstance;
    onFinish: () => void;
    onChange: (e: ITruck) => void;
    onClose: () => void;
}

const TruckWeb = (props: ITruckWeb) => {
    const { truck, headers, loading, api, onChange, onFinish, onClose, serverFetch } = props;

    return (
        <Row gutter={64}>
            <Col span={10}>
                <Form colon={false} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} onFinish={onFinish}>
                    <Form.Item initialValue={truck.number} label='Номер' name='number'>
                        <Input disabled={true} />
                    </Form.Item>

                    <Form.Item label='Маршрут' name='waypointHeaderId' initialValue={truck.waypointHeaderId}>
                        <Select
                            disabled={true}
                            options={headers.map((h) => {
                                return { value: h.id, label: h.name };
                            })}
                        />
                    </Form.Item>

                    {truck.id && (
                        <Form.Item label='Статус'>
                            <Input disabled={true} defaultValue={enumLabel(truck.status)} />
                        </Form.Item>
                    )}

                    {truck.id && (
                        <>
                            <Form.Item
                                label='Дата отгрузки'
                                name='departureOn'
                                initialValue={
                                    truck.departureOn && dayjs(truck.departureOn).utc(true).set('hour', 0).set('minute', 0).set('second', 0)
                                }
                            >
                                <DatePicker disabled={true} format={'DD.MM.YYYY'} />
                            </Form.Item>
                            <Form.Item label='Брутто'>
                                <Space.Compact>
                                    <Form.Item name='grossWeight' initialValue={truck.grossWeight} noStyle>
                                        <InputNumber decimalSeparator=',' min={0} disabled={true} stringMode />
                                    </Form.Item>
                                    <Space.Addon>кг</Space.Addon>
                                </Space.Compact>
                            </Form.Item>
                        </>
                    )}

                    <Form.Item initialValue={truck.trackingUrl} label='Трекинг URL' name='trackingUrl'>
                        <Input
                            autoFocus
                            onChange={(data: React.ChangeEvent<HTMLInputElement>) => {
                                if (!truck) return;
                                onChange({ ...truck, trackingUrl: data.target.value });
                            }}
                        />
                    </Form.Item>

                    <Form.Item label='Перевозчик'>
                        <CargoCarrier
                            defaultCargoCarrierId={truck.cargoCarrierId}
                            type={CargoCarrierType.Truck}
                            disabled={true}
                            api={api}
                            serverFetch={serverFetch}
                        />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 8, span: 16, xs: 16 }}>
                        <Space size={'small'} style={{ float: 'right' }}>
                            {
                                <Button type='text' onClick={() => onClose()}>
                                    Закрыть
                                </Button>
                            }

                            <Button type='primary' htmlType='submit' loading={loading}>
                                Сохранить
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Col>

            <Col span={14}>
                {truck.id && truck.status !== TruckStatus.New && (
                    <>
                        <Divider style={{ marginTop: 0 }} titlePlacement='left'>
                            Трекинг
                        </Divider>
                        <Trackpoints truck={truck} viewOnly={truck.status === TruckStatus.Finished} />
                    </>
                )}
            </Col>
        </Row>
    );
};

export default TruckWeb;
